/*
 * @overview:工具类
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-28 10:12:30
 */

import { UAParser } from 'ua-parser-js';

/**
 * 设备信息
 */
const uaResult = new UAParser().getResult();
export const deviceInfo = () => {
  return {
    // 浏览器版本号 107.0.0.0
    browser_version: uaResult.browser.version,
    // 浏览器
    browser: uaResult.browser.name,
    // 电脑系统版本
    os_version: uaResult.os.version,
    // 电脑系统
    os: uaResult.os.name,
    // 设备型号
    device: uaResult.device.model ? uaResult.device.model : 'Unknow',
    // 设备类型
    device_type: uaResult.device.type ? uaResult.device.type : 'Pc',
    ua: uaResult.ua,
  };
};

/**
 * 获取cookie
 */
export function getCookie(name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}
/**
 * Json对象转url参数
 * @param {*} obj
 * @returns
 */
export function objectToUrlParams(obj) {
  let params = [];
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      let value = obj[key];
      if (value !== null && typeof value !== 'undefined') {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
  }
  return params.join('&');
}
